<template>
  <el-dialog :title="params.title" :visible.sync="params.dialogVisible" width="600px" :before-close="handleClose">
    <div class="modal-icon"><i :class="['iconfont', params.icon]"></i></div>
    <div class="modal-title">{{params.head}}</div>
    <div class="modal-tips" v-html="params.content"> </div>
    <!-- <div class="modal-tips tips-orange">
      点击确定按钮，申请取消活动，申请后需要后台审核通过，
      才能取消活动
    </div> -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm" size="small" v-if="params.confirm">{{params.btn.confirmVal}}</el-button>
      <el-button @click="cancel" size="small" plain v-if="params.cancel">{{params.btn.cancelVal}}</el-button>

    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  // props: {
  //   dialogVisible: {
  //     //弹窗组件是否显示 默认不显示
  //     type: Boolean,
  //     default: false,
  //     required: true,
  //   },
  //   title: {
  //     //弹窗标题
  //     type: String,
  //     default: '标题',
  //     required: true,
  //   },
  //   content: {
  //     //弹窗内容
  //     type: Object,
  //     required: true,
  //   }
  // },
  data() {
    return {
      params: {},
      formData: { name: "ssss", id: "ssss", wid: "sssss" }
    };
  },
  computed: {},
  watch: {
    params() {
      // console.log(this.params)
    }
  },
  methods: {
    handleClose(done) {
      // console.log(done)
      // this.$emit("on-close");
    },
    // cancel() {
    //   // this.$emit("on-close");
    // },
    // confirm() {
    //   console.log("确定的呀")
    // },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "../modal.less";
</style>
